import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'myt-react-snippets'
import { useTab } from './hooks'

export const TabPane = ({eventKey, children}) => {
    const {activeKey} = useTab()
    const status = activeKey === eventKey
    const [show, setShow] = useState(status)
    useEffect(() => {
        let cleanUp
        if(status) {
            cleanUp = setTimeout(() => {
                setShow(status)
            }, 100);
        } else {
            setShow(status)
        }
        return () => clearTimeout(cleanUp)
    }, [status])
    return (
        <Transition 
            in={show}
            timing={150}
			suffix={{ enter: 'active', exit: '' }}
            >
            <div id={eventKey} className="tab-panel d-block" role="tabpanel" aria-labelledby={eventKey}>
                {children}
            </div>
        </Transition>
    )
}

TabPane.propTypes = {
    eventKey: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired
}
